export function toCurrency(value: number, minimumFractionDigits = 0, maximumFractionDigits = 0) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD',
    minimumFractionDigits,
    maximumFractionDigits
  }).format(value);
}
